import React from "react";
import { useSelector } from "react-redux";
import { HiddenVisually } from "@bookingcom/bui-react";
import { t } from "@bookingcom/lingojs-core";
import { useI18n } from "@bookingcom/lingojs-react";
import { getSearchbox } from "../../store/selectors.js";
import { useFareCalendarEnabled } from "./useFareCalendar.js";
const FareCalendarLoadingAnnouncement = ({ segmentIndex, fareCalendarConfig, mode }) => {
    const i18n = useI18n();
    const searchbox = useSelector(getSearchbox);
    const loading = searchbox.fareCalendar.loading;
    const fareCalendarEnabled = useFareCalendarEnabled(segmentIndex, fareCalendarConfig, mode);
    const fareCalendarDisplayEnabled = fareCalendarEnabled && !!fareCalendarConfig?.isFareCalendarDisplayEnabled;
    if (!fareCalendarDisplayEnabled) {
        return null;
    }
    return (React.createElement(HiddenVisually, null,
        React.createElement("div", { "aria-live": "assertive" }, loading
            ? i18n.trans(t("a11y_flights_fare_cal_loading"))
            : i18n.trans(t("a11y_flights_fare_cal_loading_complete")))));
};
export default FareCalendarLoadingAnnouncement;
